import React, { Component } from 'react'
import { connect } from 'react-redux'
import PreAuthSample from '../samples/PreAuthSample'
import { makePreauth } from '../../../actions/transactionsActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _BASIC_TRANSACTIONS, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    order_ID: ["preauth.SetOrderId(order_id);", "preauth.setOrderId(order_id);", "'order_id'=>$order_id"],
    amount: ["preauth.SetAmount(amount);", "preauth.setAmount(amount);", "'amount'=>$amount"],
    credit_card_number: ["preauth.SetPan(pan);", "preauth.setPan(pan);", "'pan'=>$pan"],
    expiry_date: ["preauth.SetExpdate(expiry_date);", "preauth.setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    electronic_commerce_indicator: ["preauth.SetCryptType(crypt);", "preauth.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    dynamic_descriptor: ["preauth.SetDynamicDescriptor(dynamic_descriptor);", "preauth.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    card_match_ID: ["preauth.SetCmId(transaction_id);", "preauth.setCmId(transaction_id);", "'cm_id' => $transaction_id"],
    Customer_Information: ["preauth.SetCustInfo(customer);", "preauth.setCustInfo(customer);", "$mpgTxn->setCustInfo($mpgCustInfo);"],
    AVS_Information: ["preauth.SetAvsInfo(avsCheck);", "preauth.setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: ["preauth.SetCvdInfo(cvdCheck);", "preauth.setCvdInfo(cvdCheck);", "$mpgTxn->setCvdInfo($mpgCvdInfo);"],
    customer_ID: ["preauth.SetCustId(cust_id);", "preauth.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    wallet_indicator: ["preauth.SetWalletIndicator(wallet_indicator);", "preauth.setWalletIndicator(wallet_indicator);", "'wallet_indicator'=>$wallet_indicator"],
    final_authorization: ["preauth.SetFinalAuth(\"true\");","preauth.setFinalAuth(\"true\");","'final_auth' => ‘true’"],
    Credential_Info: ["preauth.SetCofInfo(cof);", "preauth.setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    issuer_ID: ["cof.SetIssuerId(\"VALUE_FOR_ISSUER_ID\");", "cof.setIssuerId(\"VALUE_FOR_ISSUER_ID\");", "$cof->setIssuerId(\"VALUE_FOR_ISSUER_ID\");"],
    payment_indicator: ["cof.SetPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "cof.setPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "$cof->setPaymentIndicator\n(\"PAYMENT_INDICATOR_VALUE\");"],
    payment_information: ["cof.SetPaymentInformation(\"PAYMENT_INFO_VALUE\");", "cof.setPaymentInformation(\"PAYMENT_INFO_VALUE\");", "$cof->setPaymentInformation(\"PAYMENT_INFO_VALUE\");"],
}

export class PreAuth extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakePreAuthPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _BASIC_TRANSACTIONS, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const preAuthRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makePreauth(preAuthRequest);
    }

    renderIntegrationTool() {
        return(
            <div className="stepMainContainer">
            <h3>Sample Pre-Authorization</h3>
            <PreAuthSample />
            <div className="requestButton" onClick={() => this.onMakePreAuthPress()}>
                Pre-Authorization Request
            </div> 
        </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Pre-Authorization</b></span>
                <p style={{marginTop: '3vh'}}>Verifies and locks funds on the customer’s credit card. The funds are locked for a specified amount of time based on the card issuer.</p>
                <p>To retrieve the funds that have been locked by a Pre-Authorization transaction so that they may be settled in the merchant’s account, a Pre-Authorization Completion transaction must be performed. A Pre-Authorization transaction may only be "completed" once.</p>
                
                <div className='thingsToConsider'>
                    <h3>Things to Consider: </h3>
                    <ul>
                        <li>If a Pre-Authorization transaction is not followed by a Pre-Authorization Completion transaction, it must be reversed via a Pre-Authorization Completion transaction for 0.00. See 2.3 Pre-Authorization Completion</li>
                        <br />
                        <li>A Pre-Authorization transaction may only be "completed" once</li>
                    </ul>
                </div>

                <p><b>Pre-Authorization transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>PreAuth preauth = new PreAuth();</code>
                    case _JAVA:
                        return <code>PreAuth preauth = new PreAuth();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’preauth', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Pre-Authorization transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(preauth);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(preauth);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Pre-Authorization transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>amount</td>
                        <td><i>String</i><br /><br />10-character decimal<br />Up to 7 digits (dollars) +<br />decimal point (.) + 2 digits<br />(cents) after the decimal<br />point</td>
                        <td><code>{CODES.amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br />20-character alphanumeric</td>
                        <td><code>{CODES.credit_card_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>expiry date</td>
                        <td><i>String</i><br /><br />4-character alphanumeric<br />(YYMM format)</td>
                        <td><code>{CODES.expiry_date[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>Pre-Authorization transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric</td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>card match ID<br /><br /><p className="note"><b>NOTE: </b> Applies to Offlinx™ only;<br /> must be unique value for each transaction</p></td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.card_match_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>Customer Information</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Customer_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>AVS Information</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.AVS_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>CVD Informationbr<br /><p className="note"><b>NOTE: </b>When storing credentials on the initial transaction, the CVD object must be sent; for subsequent transactions using stored credentials, CVD can be sent with cardholder-initiated transactions only—merchants must not store CVD information.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.CVD_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b>{"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>wallet indicator<br /><br /><p className="note"><b>NOTE: </b> For basic Purchase and Preauthorization, the wallet indicator applies to Visa Checkout and MasterCard MasterPass only. For more, see Definition of Request Fields.</p></td>
                        <td><i>String</i><br /><br />3-character alphanumeric</td>
                        <td><code>{CODES.wallet_indicator[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>final authorization<br /><br /><p className="note"><b>NOTE: </b> Applies to Mastercard transactions onl</p></td>
                        <td><i>String</i><br /><br />true/false</td>
                        <td><code>{CODES.final_authorization[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>Credential on File Info<br />cof<br /><br /><p className="note"><b>NOTE: </b>This is a nested object within the transaction, and required when storing or using the customer's stored credentials. For information about fields in the Credential on FIle Info object, see Credential on File Info Object and Variables.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Credential_Info[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Credential on File Info object request fields</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>issuer ID<br /><br /><p className="note"><b>NOTE: </b>This variable is required for all merchant-initiated transactions following the first one; upon sending the first transaction, the issuer ID value is received in the transaction response and then used in subsequent transaction requests.</p></td>
                        <td><i>String</i><br /><br />15-character alphanumeric<br />variable length</td>
                        <td><code>{CODES.issuer_ID[progLangId]}</code><br /><br /><p className="note"><b>NOTE: </b>For a list and explanation of the possible values to send for this variable, see Definition of Request Fields – Credential on File</p></td>
                    </tr>
                    <tr>
                        <td>payment indicator<br /><br /><p className="note"><b>NOTE: </b>In Credential on File transactions where the request field e-commerce indicator is also being sent, the acceptable values for ecommerce indicator are dependent on the value sent for payment indicator; see request field definitions for more information.</p></td>
                        <td><i>String</i><br /><br />1-character alphabetic</td>
                        <td><code>{CODES.payment_indicator[progLangId]}</code><br /><br /><p className="note"><b>NOTE: </b>For a list and explanation of the possible values to send for this variable, see Definition of Request Fields – Credential on File</p></td>
                    </tr>
                    <tr>
                        <td>payment information</td>
                        <td><i>String</i><br /><br />1-character alphabetic</td>
                        <td><code>{CODES.payment_information[progLangId]}</code><br /><br /><p className="note"><b>NOTE: </b>For a list and explanation of the possible values to send for this variable, see Definition of Request Fields – Credential on File</p></td>
                    </tr>
                </table>

            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount } = state.transactions.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePreauth, updateOrderId})(PreAuth)
